type question = {
  key: string;
  label: string;
  answers?: string[];
};

type WelcomeSurveyResult = {
  how_did_you_hear_about: string;
  how_did_you_hear_about_other: string;
  eating_habits: string;
  how_many_meals_each_week: string;
  primary_reason: string;
  primary_reason_other: string;
  food_is_medicine: string;
  how_often_go_to_the_gym: string;
  using_pc: string;
  have_you_tried_other_meals: string;
  have_you_tried_other_meals_other: string;
  chosen_meal_kit: string;
  chosen_meal_kit_other: string;
  fun_to_make_the_meals: string;
  gender: string;
  birthday: string;
  number_of_people_in_household: string;
};

class WelcomeSurvey {
  static questions: question[] = [
    {
      key: 'how_did_you_hear_about',
      label: 'How did you hear about Purple Carrot?',
      answers: [
        'Article or blog post',
        'Purple Carrot Frozen Meals',
        'Received as a gift',
        'TV ad',
        'YouTube',
        'I ordered a Purple Carrot seasonal box',
        'Sharecare Scaleback',
        'Online research',
        'Friend or family member',
        'Fruit Street',
        'My doctor or dietician',
        'Podcast',
        'Social Media',
        'Mailer',
        'Spotify',
        'Other',
      ],
    },
    {
      key: 'eating_habits',
      label: 'Which of the following describes your plant-based (vegan) '
        + 'eating habits? By plant-based, we mean meals that do not include'
        + 'meat, fish or dairy.',
      answers: [
        'I eat exclusively plant-based meals',
        'The majority of my meals are plant-based',
        'I’m trying to eat a few plant-based meals per week',
        'I’ve never tried plant-based meals (other than Purple Carrot now)',
        'I don\'t seek out or avoid plant-based meals',
      ],
    },
    {
      key: 'how_many_meals_each_week',
      label: 'We typically eat 21 meals a week. On average, how many meals '
        + 'do you eat each week that are plant based? By plant-based, we mean '
        + 'meals that do not include meat, fish or dairy.',
      answers: ['0', '1-3', '4-10', '11-18+'],
    },
    {
      key: 'primary_reason',
      label: 'What is the primary reason you chose to sign up for Purple '
        + 'Carrot\'s meal kit?',
      answers: [
        'I\'m trying to lead a healthier lifestyle',
        'To support the rights of animals',
        'I\'m 100% plant-based, or someone in my family is',
        'I\'m vegetarian/vegan, and Purple Carrot has the best plant-based meals',
        'To help protect the environment',
        'I\'m eating plant-based due to personal or family health issues',
        'For recipe inspiration',
        'I want to learn how to cook plant-based meals',
        'Other',
      ],
    },
    {
      key: 'food_is_medicine',
      label: 'How strongly do you agree or disagree with the statement: "Food '
        + 'is medicine"?',
      answers: ['1', '2', '3', '4', '5', '6', '7'],
    },
    {
      key: 'how_often_go_to_the_gym',
      label: 'Prior to the COVID-19 pandemic, on a regular basis, not including '
        + 'the holidays or special occasions, how often would you say you go to '
        + 'the gym?',
      answers: [
        'Never',
        '1 or 2 times a month or less often',
        'Several times a month',
        '1 to 3 times a week',
        'Several times a week or more',
      ],
    },
    {
      key: 'using_pc',
      label: 'How long are you planning on using Purple Carrot?',
      answers: [
        'Less than a month',
        'A few months',
        'More than a few months',
      ],
    },
    {
      key: 'have_you_tried_other_meals',
      label: 'Have you tried any other meal kits?',
      answers: ['Yes', 'No'],
    },
    {
      key: 'chosen_meal_kit',
      label: 'Why did you choose to sign up for a meal kit?',
      answers: [
        'To minimize dinnertime decision making',
        'To prepare restaurant-quality food',
        'To minimize trips to the grocery store',
        'Looking for new recipe ideas',
        'Learning to cook',
        'Easy-to-follow recipes',
        'To save money',
        'To reduce food waste',
        'Other',
      ],
    },
    {
      key: 'fun_to_make_the_meals',
      label: 'When cooking meals at home, how important is it to you that it '
        + 'will be fun to make the meal?',
      answers: ['1', '2', '3', '4', '5', '6', '7'],
    },
    {
      key: 'gender',
      label: 'What is your gender?',
      answers: [
        'Female',
        'Male',
        'Non-binary',
        'Prefer not to say',
      ],
    },
    {
      key: 'birthday',
      label: 'Tell us your birthday',
    },
    {
      key: 'number_of_people_in_household',
      label: 'How many people are in your household?',
      answers: ['1', '2', '3', '4', '5', '6+'],
    },
  ];

  static getEmptySurvey(): WelcomeSurveyResult {
    return {
      how_did_you_hear_about: '',
      how_did_you_hear_about_other: '',
      eating_habits: '',
      how_many_meals_each_week: '',
      primary_reason: '',
      primary_reason_other: '',
      food_is_medicine: '',
      how_often_go_to_the_gym: '',
      using_pc: '',
      have_you_tried_other_meals: '',
      have_you_tried_other_meals_other: '',
      chosen_meal_kit: '',
      chosen_meal_kit_other: '',
      fun_to_make_the_meals: '',
      gender: '',
      birthday: '',
      number_of_people_in_household: '',
    };
  }
}

export default WelcomeSurvey;
